export const API_URL = import.meta.env.VITE_API_URL || "/api";
export const MC_URL = import.meta.env.VITE_MC_URL || "https://dev.api.emporiaqa.com";
export const GOOGLE_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  "478761400401-mhmjeor34vgig2f510fkoq71bjaphp70.apps.googleusercontent.com";
